import React, { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ControlGroup from "@amzn/meridian/control-group";
import {optionsAddedOrChanged} from "../../actions/OptionsActions";
import RadioButton from "@amzn/meridian/radio-button";
import {FormattedMessage} from "react-intl";

class CycleOptions extends Component {

    componentDidMount() {
        if(this.props.allCycles.length !== 0 && this.props.selectedCycle.length === 0) {
            this.handleCycleChange(this.props.allCycles[0].cycleId,this.props.allCycles)
        }
    }

    render() {

        const {allCycles, selectedCycle} = this.props;
        return (
            <ControlGroup label={<FormattedMessage id="cycleOptions.cycle" defaultMessage="Cycle"/>}
                          onChange={updatedCycle => this.handleCycleChange(updatedCycle, allCycles)} value={selectedCycle}>
                {allCycles.map(cycle => (
                    <RadioButton key={cycle.cycleName} value={cycle.cycleName} data-cy={"cycleFieldsetOption"}>{cycle.displayableName}</RadioButton>
                ))}
            </ControlGroup>
        )
    }

    handleCycleChange(updatedCycle, allCycles) {
        this.props.dispatch(optionsAddedOrChanged(
            {
                'cycle': updatedCycle
            }))
        this.props.dispatch(optionsAddedOrChanged(
            {
                'cycleId': allCycles.filter(cycle => cycle.cycleId === updatedCycle).map(cycle => cycle.casCycleId)[0]
            }))
    }
}

const mapStateToProps = state => ({
    selectedCycle: state.optionsReducer.options.cycle,
    allCycles: state.optionsReducer.allCycles
});
export default withRouter(connect(mapStateToProps)(CycleOptions));



// WEBPACK FOOTER //
// ./src/components/options/CycleOptions.js